import { select } from "@angular-redux/store";
import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { PageChangeEvent } from "@progress/kendo-angular-dropdowns/dist/es2015/common/models/page-change-event";
import { GridDataResult, SelectableSettings } from "@progress/kendo-angular-grid";
import { orderBy, SortDescriptor, State } from "@progress/kendo-data-query";
import { Observable } from "rxjs";
import { UserAuthorizationActions } from "../../user-authorization.actions";

@Component({
    selector: "users-table",
    templateUrl: "./users-table.component.html",
})

export class UsersTableComponent implements OnInit {

    @select('filteredAzureUsers') public azureUsers$: Observable<any>;
    @select("selectedAzureUsers") public selectedAzureUsers$: Observable<any[]>;

    @ViewChild("UsertableParent", { static: true }) public tableParent: ElementRef;

    public azureUsers: any[] = [];

    public azureUsersGridResult: GridDataResult;

    public columnNames = [
        { title: "Display Name", field: "displayName" },
        { title: "First Name", field: "firstName" },
        { title: "Email", field: "email" }
    ];


    public mySelection: any[] = [];
    public mySelectionKeys: number[] = [];

    public state: State = {
        skip: 0,
        take: 50,
    };
    public selectableSettings: SelectableSettings = {
        checkboxOnly: false,
        mode: "single",
    };
    public tableWidth: number;
    public windowHeight: number;
    public tableHeight: number;
    public tooltipOffset = { left: 0, top: 0 };
    public tooltipVisible = false;
    public tooltipValue = "";
    public GRID_RATIO = 0.833;
    public GRID_FILLER_SPACE = 82.8;

    public gridUser: any;
    constructor(private readonly userAuthorizationActions: UserAuthorizationActions) {

    }
    ngOnInit(): void {
        this.tableWidth = this.tableParent.nativeElement.offsetWidth;
        this.setGridDimensions();
        this.azureUsers$.subscribe((data) => {
            if (data) {
                this.azureUsers = data;
                this.setGridContent();
            }
        })

        this.selectedAzureUsers$.subscribe((data) => {
            if (data && data.length > 0) {
                this.mySelection = data;
            } else {
                this.mySelection = [];
                this.mySelectionKeys = [];
            }
        })
    }

    public setGridContent() {
        this.azureUsersGridResult = {
            data: [...this.azureUsers.slice(this.state.skip, this.state.skip + this.state.take)],
            total: this.azureUsers.length,
        }
    }

    public pageChange(event: PageChangeEvent): void {
        this.state.skip = event.skip;
        this.setGridContent();
    }


    public sortChange(sort: SortDescriptor[]): void {
        this.state.sort = sort;
        this.azureUsers = orderBy([...this.azureUsers], sort);

        this.azureUsersGridResult = {
            data: this.azureUsers.slice(this.state.skip, this.state.skip + this.state.take),
            total: this.azureUsers.length,
        };
    }

    public rowClicked(gridUser, selection): void {

        if (selection.selectedRows && selection.selectedRows.length > 0) {
            this.mySelection = [...this.mySelection.concat(selection.selectedRows.map((x) => x.dataItem))];
        }

        if (selection.deselectedRows && selection.deselectedRows.length > 0) {
            const deslectectedContainers = selection.deselectedRows.map((x) => x.dataItem);
            this.mySelection = [...this.mySelection.filter((x) => deslectectedContainers.indexOf(x) === -1)];
        }

        this.userAuthorizationActions.setSelectedAzureUsers(this.mySelection);
    }

    public refreshTableDisplay(): void {
        this.state.skip = 0;
        this.setGridContent();
    }


    public setGridDimensions(): void {
        this.windowHeight = window.screen.height;
        this.tableHeight = this.windowHeight >= 1080 ? this.windowHeight * this.GRID_RATIO : 480;
        const rowHeight = (this.tableHeight - this.GRID_FILLER_SPACE) / this.state.take;
        document.querySelector("body").style.cssText = "--row-height: " + rowHeight + "px";
        this.refreshTableWidth();
    }

    public refreshTableWidth(): void {
        this.tableWidth = this.tableParent.nativeElement.offsetWidth;
    }


}